import { Component } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { Observable, map } from 'rxjs';
import { TourService } from '../../../shared/tour/tour.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class AppHeaderComponent {

  /** Signed-in address, for the account menu. Was a hardcoded "QA". */
  readonly email$: Observable<string | null>;

  /** The address's first letter, on the avatar. */
  readonly initial$: Observable<string>;

  constructor(private router: Router, private auth: AuthService, public tour: TourService) {
    this.email$ = this.auth.email$;
    this.initial$ = this.auth.email$.pipe(map(e => (e ? e[0].toUpperCase() : '?')));
  }

  logout() {
    // Ends the Cognito session as well; clearing local tokens alone would sign straight back in
    // on the next redirect. Cognito returns the browser to the configured post-logout URL.
    this.auth.logout();
  }

  protected readonly environment = environment;
}
